const adminActions = {
  UPDATE_USER_FILTERS: "UPDATE_USER_FILTERS",

  updateUserFilters(data) {
    return { type: this.UPDATE_USER_FILTERS, data };
  },
};

export default adminActions;
